export default __webpack_public_path__ + "static/media/manIlustration.c0a16f7e.webp";